import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockFullLoggedOutUserNoRecentCourses: MockResponseConfig = {
  ...mockFullLoggedOutUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          ...mockFullLoggedOutUser.UnifiedProfileQuery(variables).data.unified
            .unifiedProfile,
          username: 'loggedoutnorecentcourses',
        },
      },
    },
  }),
  ProfileBadgesQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          aaid: '62587f99fdb60b0069294184',
          learning: {
            __typename: 'UnifiedLearning',
            id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184',
            recentCoursesBadges: {
              __typename: 'UnifiedProfileBadgesConnection',
              edges: [],
              totalCount: 0,
            },
          },
          badges: {
            __typename: 'UnifiedProfileBadgesConnection',
            edges: [
              {
                node: {
                  description: 'Answer 1 question tagged “cloud”',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-kms-4837589',
                  imageUrl:
                    'https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530',
                  name: 'Cloudie',
                  type: 'kms',
                },
              },
              {
                node: {
                  description: 'Answers accepted',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-7',
                  imageUrl: '',
                  name: 'First Accepted Solution',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: null,
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-37',
                  imageUrl: '',
                  name: 'Level 0',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Likes received',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-15',
                  imageUrl: '',
                  name: 'First Like Received',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: null,
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-31',
                  imageUrl: '',
                  name: 'Test Peter',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Topics discussed',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-12',
                  imageUrl: '',
                  name: '5 Topics Discussed',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Topics discussed',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-11',
                  imageUrl: '',
                  name: 'First Topic Discussed',
                  type: 'khoros',
                },
              },
              {
                node: {
                  description: 'Role badges',
                  id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge-khoros-20',
                  imageUrl: '',
                  name: 'Atlassian Team',
                  type: 'khoros',
                },
              },
            ],
            pageInfo: {
              endCursor: '1103',
              hasNextPage: false,
              hasPreviousPage: false,
              startCursor: '0',
            },
            totalCount: 1103,
          },
        },
      },
    },
  }),
};
